import { render, staticRenderFns } from "./protect-your-eyes-and-ears-a45.vue?vue&type=template&id=667f331c"
import script from "./protect-your-eyes-and-ears-a45.vue?vue&type=script&lang=js"
export * from "./protect-your-eyes-and-ears-a45.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports